import React, { useState, useEffect, useCallback } from 'react'
import { searchTopBases, searchChpps, searchPrivatePoints } from 'service/AdminPanelService'

/**
 * Компонент для поиска и выбора базы (ТОП-База, ТЭЦ, Соц.объект/МСУ)
 * с динамической подгрузкой результатов по поиску
 */
const BaseSearchSelect = ({ 
  baseType = 'top_base', // 'top_base' | 'chpp' | 'private_point'
  value = '', // ID выбранной базы
  onChange = () => {}, // callback(id)
  placeholder = 'Поиск базы...',
  style = {}
}) => {
  const [searchQuery, setSearchQuery] = useState('')
  const [searchResults, setSearchResults] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [debounceTimer, setDebounceTimer] = useState(null)

  // Функция для выполнения поиска
  const performSearch = useCallback(async (query) => {
    if (!query || query.trim().length < 1) {
      setSearchResults([])
      return
    }

    setIsLoading(true)
    try {
      let response
      if (baseType === 'chpp') {
        response = await searchChpps(query.trim(), 20)
      } else if (baseType === 'private_point') {
        response = await searchPrivatePoints(query.trim(), 20)
      } else {
        response = await searchTopBases(query.trim(), 20)
      }
      
      const data = response?.data?.data || response?.data || []
      setSearchResults(Array.isArray(data) ? data : [])
    } catch (error) {
      console.error('Failed to search bases:', error)
      setSearchResults([])
    } finally {
      setIsLoading(false)
    }
  }, [baseType])

  // Обработка изменения поискового запроса с debounce
  const handleSearchChange = (e) => {
    const query = e.target.value
    setSearchQuery(query)

    // Очищаем предыдущий таймер
    if (debounceTimer) {
      clearTimeout(debounceTimer)
    }

    // Устанавливаем новый таймер
    const timer = setTimeout(() => {
      performSearch(query)
    }, 300) // 300ms задержка

    setDebounceTimer(timer)
  }

  // Очистка таймера при размонтировании
  useEffect(() => {
    return () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer)
      }
    }
  }, [debounceTimer])

  // Загружаем начальные результаты при монтировании или смене типа базы
  useEffect(() => {
    performSearch('')
  }, [baseType, performSearch])

  return (
    <div style={{ display: 'inline-block', minWidth: 220, ...style }}>
      <input 
        placeholder={placeholder}
        value={searchQuery} 
        onChange={handleSearchChange}
        style={{ width: '100%', marginBottom: 4 }}
      />
      <select 
        value={value || ''} 
        onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)}
        style={{ width: '100%' }}
        disabled={isLoading}
      >
        <option value="">— Выберите —</option>
        {searchResults.map(base => (
          <option key={base.id} value={base.id}>
            {base.name}
          </option>
        ))}
      </select>
      {isLoading && (
        <div style={{ fontSize: '12px', color: '#666', marginTop: 2 }}>
          Загрузка...
        </div>
      )}
    </div>
  )
}

export default BaseSearchSelect
